import { ReactElement } from 'react'

export interface Banner {
  key: BannerKey
  content: ReactElement
  priority: Priority
  type: BannerType
  locations: BannerLocation[]
}

export enum Priority {
  Highest = 3,
  High = 2,
  Medium = 1,
  Low = 0,
}

export enum BannerType {
  Info = 'info',
  Warning = 'warning',
}

export const AllSettingPages = [
  'settings-overview',
  'settings-solar',
  'settings-battery',
  'settings-power-meter',
  'settings-wallbox',
  'settings-smart-charge',
  'settings-smart-power',
  'settings-emergency-power',
  'settings-installation',
] as const

export const AllFlowSettingPages = [
  'flow-settings-grid-and-system-protection',
  'flow-settings-solar-priority',
  'flow-settings-rfid-charging-cards',
  'flow-settings-wallbox',
  'flow-settings-storage-management',
  'flow-settings-boiler',
] as const

export const FlowAdvancedSettingsTabs = [
  'flow-settings-advanced-settings-overview',
  'flow-settings-advanced-settings-storage',
  'flow-settings-advanced-settings-charging-station',
  'flow-settings-advanced-settings-hvac',
  'flow-settings-advanced-settings-power-meter',
  'flow-settings-advanced-settings-io',
] as const

export enum BannerLocations {
  Dashboard = 'dashboard',
  SystemStatus = 'system-status',
  Documentation = 'documentation',
  RightsAdministration = 'rights-administration',
  SettingsOverview = 'settings-overview',
  SettingsSolar = 'settings-solar',
  SettingsBattery = 'settings-battery',
  SettingsPowerMeter = 'settings-power-meter',
  SettingsWallbox = 'settings-wallbox',
  SettingsSmartCharge = 'settings-smart-charge',
  SettingsSmartPower = 'settings-smart-power',
  SettingsTariffs = 'settings-tariffs',
  SettingsEmergencyPower = 'settings-emergency-power',
  SettingsInstallation = 'settings-installation',
  FlowSettingsGridAndSystemProtection = 'flow-settings-grid-and-system-protection',
  FlowSettingsAdvancedSettingsOverview = 'flow-settings-advanced-settings-overview',
  FlowSettingsAdvancedSettingsStorage = 'flow-settings-advanced-settings-storage',
  FlowSettingsAdvancedSettingsChargingStation = 'flow-settings-advanced-settings-charging-station',
  FlowSettingsAdvancedSettingsHvac = 'flow-settings-advanced-settings-hvac',
  FlowSettingsAdvancedSettingsPowerMeter = 'flow-settings-advanced-settings-power-meter',
  FlowSettingsAdvancedSettingsIo = 'flow-settings-advanced-settings-io',
  FlowSettingsSolarPriority = 'flow-settings-solar-priority',
  FlowSettingsRfidChargingCards = 'flow-settings-rfid-charging-cards',
  FlowSettingsWallbox = 'flow-settings-wallbox',
  FlowSettingsStorageManagement = 'flow-settings-storage-management',
  FlowSettingsBoiler = 'flow-settings-boiler',
  Emobility = 'emobility',
  InstallerDashboard = 'installer-dashboard',
  ServiceDashboard = 'service-dashboard',
  OwnerOverview = 'owner-overview',
  EmobilityRoot = 'emobility-root',
  EmobilityCountryInfoMissingWallboxes = 'wallbox',
  EmobilityCountryInfoMissingTariffs = 'tariffs',
  EmobilityCountryInfoMissingSessions = 'charging-sessions',
  EmobilityTour = 'emobility-tour',
  UserDetails = 'user-details',
  SystemDetails = 'system-details',
}

export type BannerLocation = `${BannerLocations}`

export enum BannerKey {
  DirectMarketing = 1,
  OfflineInstallationBanner = 2,
  ReadOnlyBanner = 3,
  SunModeDisabledBanner = 4,
  ReadOnlyBannerEmobility = 5,
  ReferralBanner = 6,
  ActiveVariableDynamicPowerPriceAlertBanner = 7,
  DynamicEmsBanner = 8,
  InstallationStatementDeadlineOverviewBanner = 9,
  InstallationStatementDeadlineDashboardBanner = 10,
  UserDeletedBanner = 11,
  /** @deprecated */
  VehicleIntegrationReleaseBanner = 12, // we don't use it anymore but the id is stored in DB to hide banner, so we keep it here.
  EmobilityCountryInfoMissingSessionBanner = 13,
  EmobilityCountryInfoMissingTariffsBanner = 14,
  EmobilityNewBackendUnavailableBanner = 15,
  EmobilityTourBanner = 16,
  EmobilityCountryInfoMissingWallboxesBanner = 17,
  AI360ReleaseBanner = 18,
  /** @deprecated */
  EonContractBanner = 19, // we don't use it anymore but the id is stored in DB to hide banner, so we keep it here.
  NewVehicleManufacturersBanner = 20,
  EonOfferBanner = 21,
  Ai360TariffsBanner = 22,
  ContinueAi360TariffOrderBanner = 23,
}

export enum BannerCloseTypes {
  Temporary = 'temporary',
  permanentOrTemporary = 'permanentOrTemporary',
  Permanent = 'permanent',
}

export type BannerCloseType = `${BannerCloseTypes}`
